module.exports = __webpack_public_path__ + "54dfb9055152eda828b089f3dc826d17.png";